import React from "react";

const GDPRPolicy = () => {
  return (
    <div className="legal-section">
      <h2>GDPR Information</h2>
      <p>Last updated: March 19, 2024</p>

      <h3>1. Introduction</h3>
      <p>
        This section provides information about how SocratesLab handles data in
        the context of the European Union's General Data Protection Regulation
        (GDPR). Our platform is built on Google Firebase, which maintains GDPR
        compliance for its infrastructure services.
      </p>

      <h3>2. Our Infrastructure Provider</h3>
      <p>
        We use Firebase as our platform infrastructure, which maintains several
        certifications and compliances, including:
      </p>
      <ul>
        <li>Data processing according to GDPR requirements</li>
        <li>Security measures aligned with EU data protection standards</li>
        <li>Built-in tools for data privacy and security</li>
      </ul>

      <h3>3. Data Processing Information</h3>
      <p>
        While we strive to handle personal data responsibly, users should be
        aware that:
      </p>
      <ul>
        <li>Data is processed and stored using Firebase's infrastructure</li>
        <li>Firebase's security features are implemented in our platform</li>
        <li>We utilize Firebase's built-in privacy controls</li>
      </ul>

      <h3>4. Your Rights</h3>
      <p>
        The GDPR provides certain rights to EU residents. Through our platform,
        you may:
      </p>
      <ul>
        <li>Request access to your personal data</li>
        <li>Request corrections to your data</li>
        <li>Request deletion of your data</li>
        <li>Object to certain data processing</li>
      </ul>

      <h3>5. Data Transfers</h3>
      <p>
        Our use of Firebase means that data may be processed in various global
        locations. Firebase maintains appropriate safeguards for international
        data transfers, including:
      </p>
      <ul>
        <li>Standard Contractual Clauses</li>
        <li>Appropriate security measures</li>
        <li>Transparent data processing practices</li>
      </ul>

      <h3>6. Contact Information</h3>
      <p>
        For questions about data handling or to exercise your rights, please
        contact us at info@socrateslab.com. Note that response times may vary,
        and some requests may be limited by technical or legal constraints.
      </p>
    </div>
  );
};

export default GDPRPolicy;
